export default function AdminTableFooter({
  count,
  countLabel = "results",
  page,
  totalPages,
  onPrevious,
  onNext,
  lastRefreshed,
  children,
}) {
  const showPagination =
    page != null && totalPages != null && (onPrevious || onNext);

  return (
    <footer className="admin-console__table-footer">
      <div className="admin-console__table-footer-meta">
        {count != null ? (
          <span className="admin-console__result-count">
            <strong>{count}</strong> {countLabel}
          </span>
        ) : null}
        {lastRefreshed ? (
          <span className="admin-console__last-refreshed muted">
            Updated {lastRefreshed}
          </span>
        ) : null}
        {children}
      </div>
      {showPagination ? (
        <div className="admin-console__pagination">
          <button
            type="button"
            className="admin-btn admin-btn--secondary"
            disabled={page <= 1}
            onClick={onPrevious}
          >
            Previous
          </button>
          <span className="admin-console__pagination-label">
            Page {page} of {Math.max(totalPages, 1)}
          </span>
          <button
            type="button"
            className="admin-btn admin-btn--secondary"
            disabled={page >= totalPages}
            onClick={onNext}
          >
            Next
          </button>
        </div>
      ) : null}
    </footer>
  );
}
